export enum WorkStatus {
  DONE = 'done',
  ONGOING = 'ongoing',
  TODO = 'todo',
}
